import type { World } from '../ecs/world'
import { PALETTE } from '../render/palette'
import { damageEntity } from './damage'

/**
 * Sim-side amenity effects that need per-tick work: LINGERING SANCTION
 * damage fields and SURPLUS METABOLISM shield decay. The other amenities
 * hook single events at their own sites (kill shrapnel in damage.ts, heavy
 * cooldown in player.ts, OVERRIDE charge and the invoice refund in game.ts).
 */
export function amenitiesSystem(world: World, dt: number): void {
  // lingering fields: periodic ticks against network assets inside the radius
  if (world.fields.length > 0) {
    const cfg = world.tuning.amenities.lingering
    for (const f of world.fields) {
      f.t -= dt
      f.tickT -= dt
      if (f.tickT <= 0) {
        f.tickT += cfg.tickInterval
        for (const e of world.entities) {
          if (e.dead || (e.kind !== 'enemy' && e.kind !== 'generator' && e.kind !== 'boss')) continue
          if ((e.x - f.x) ** 2 + (e.y - f.y) ** 2 > f.r * f.r) continue
          damageEntity(world, e, cfg.tickDamage, 'magic')
        }
        world.burst(f.x, f.y, PALETTE.magic, 3, 90, 0.3, 2)
      }
    }
    world.fields = world.fields.filter((f) => f.t > 0)
  }

  // shield decay (metabolism): the buffer is borrowed time, not a stat
  for (const p of world.players()) {
    if (p.shield && p.shield > 0) {
      p.shield = Math.max(0, p.shield - world.tuning.amenities.metabolism.decayPerSecond * dt)
    }
  }
}
